import { api } from './api';
import type { CommandResult, CommandRunning } from './types';

/** How long each follow-up asks the plane to hold, in seconds (it holds at most 50). */
const FOLLOW_WAIT_S = 50;

export interface CommandInput {
  cmd: string;
  cwd?: string;
  envs?: Record<string, string>;
  timeoutMs?: number;
}

/**
 * Runs a command in a sandbox and resolves with its result, however long it
 * runs. The plane answers POST …/commands within 50 s: the result when the
 * command ended in time, else 202 and a commandId. This follows that id with
 * GET …/commands/:commandId?wait=50 until the result comes back. A command's
 * own failure (e.g. 400 bad-path, 504) rejects as an ApiError, the same as on
 * the first call.
 */
export async function runCommand(
  sandboxId: string,
  input: CommandInput,
  { signal, onRunning }: { signal?: AbortSignal; onRunning?: (running: CommandRunning) => void } = {},
): Promise<CommandResult> {
  const base = `/v1/sandboxes/${encodeURIComponent(sandboxId)}/commands`;
  let answer = await api<CommandResult | CommandRunning>(base, { method: 'POST', body: input, signal });
  while (answer.state === 'running') {
    onRunning?.(answer);
    answer = await api<CommandResult | CommandRunning>(`${base}/${encodeURIComponent(answer.commandId)}?wait=${FOLLOW_WAIT_S}`, { signal });
  }
  return answer;
}
